var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileCopyLine = function SvgFileCopyLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 6.6V3.9a.9.9 0 0 1 .9-.9h10.8a.9.9 0 0 1 .9.9v12.6a.9.9 0 0 1-.9.9H17v2.7c0 .497-.405.9-.906.9H5.306a.9.9 0 0 1-.906-.9l.003-12.6c0-.497.405-.9.906-.9zM6.203 8.4 6.2 19.2h9V8.4zM9.8 6.6H17v9h1.8V4.8h-9z"
  })));
};
export default SvgFileCopyLine;